import React, { createContext, useContext, useEffect, useState } from "react";
import { useMembershipInfo } from "@queries/useMembershipInfo";
import { AuthContext } from "@context/AuthContext";

export const MembershipContext = createContext({});

const MembershipContextProvider = ({ children }) => {
    const { user, setUserAuth } = useContext(AuthContext);
    const { memberData, isMembershipExpired, isMembershipInfoLoading } = useMembershipInfo(user);
    const [selectedMembershipId, setSelectedMembershipId] = useState(0);

    useEffect(() => {
        if (memberData?.subscriber) {
            setUserAuth(prev => ({ ...prev, user: memberData.subscriber }));
        }
    }, [memberData?.subscriber]);

    return (
        <MembershipContext.Provider
            value={{
                isMembershipLoading:isMembershipInfoLoading,
                isMembershipExpired,
                memberData,
                selectedMembershipId,
                setSelectedMembershipId,
            }}
        >
            {children}
        </MembershipContext.Provider>
    );
};

export default MembershipContextProvider;
